import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { PageHeader } from '@retailer-platform/shared-components'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { NotificationList } from 'domains/notifications/components/notifications-list/NotificationsList'
import { useRetailerId } from 'utils/routing/params.hooks'
import { useDashMessage } from 'intl/intl.hooks'
import { useFetchCurrentEnterpriseAccountQuery } from '__codegen__/api'
import { LoadingPage } from 'gin-and-tonic/containers/loading-page/LoadingPage'

interface Props
  extends DashRouteComponentProps<{
    /*
    Add here any properties that you expect to come from the route. For instance,

    id: string
  */
  }> {}

const NotificationListContainer = styled.div({
  padding: '1em',
})

export const NotificationsListPage: FunctionComponent<Props> = () => {
  const retailerId = useRetailerId()
  const { data, loading } = useFetchCurrentEnterpriseAccountQuery({ variables: {} })
  const title = useDashMessage('notificationsDomain.list.pageTitle')

  if (!data || loading) return <LoadingPage />
  const { id } = data.currentEnterpriseAccount
  return (
    <div data-testid="notifications-page">
      <DocumentTitle titleId="notificationsDomain.list.pageTitle" />
      <PageHeader addBottomPadding title={title} />
      <NotificationListContainer>
        <NotificationList retailerId={retailerId} accountId={id} />
      </NotificationListContainer>
    </div>
  )
}
